export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./general.vue?vue&type=template&id=5ae59c70"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/view/general.vue?vue&type=template&id=5ae59c70
// module id = m6wO
// module chunks = 0